import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTASection } from './components/FinalCTASection';
import { BookingModal } from './components/BookingModal';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleBookCall = () => {
    setIsModalOpen(true);
  };
  return <div className="min-h-screen bg-navy" data-id="element-0">
      <HeroSection onBookCall={handleBookCall} data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection onBookCall={handleBookCall} data-id="element-3" />
      <HowItWorksSection data-id="element-4" />
      <GuaranteeSection data-id="element-5" />
      <FinalCTASection onBookCall={handleBookCall} data-id="element-6" />

      <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-7" />
    </div>;
}